import { HiddenGroupChatListPanel } from "./HiddenGroupChatListPanel";
import { HiddenGroupChatListSearchView } from "./HiddenGroupChatListSearchView";
import * as React from "react";
import { useState } from "react";
import { FilteredHiddenChatsContext } from "hhn-commons";
import { ChatListSearchAndFilter } from "../ChatListSearchAndFilter";
import { GROUP_TYPE } from "@home-health-notify/domain";

type HiddenGroupsType = {
  selectedChatId?: string;
  unreadChatCount: number;
};

function HiddenGroups({ selectedChatId, unreadChatCount }: HiddenGroupsType) {
  const [searchMode, setSearchMode] = useState(false);

  const showSearchPanel = (): void => setSearchMode(true);
  const showChatListPanel = (): void => setSearchMode(false);

  const { fetchChats, resetChats } = React.useContext(
    FilteredHiddenChatsContext,
  );

  return (
    <>
      <ChatListSearchAndFilter
        showSearchPanel={showSearchPanel}
        showChatListPanel={showChatListPanel}
        groupType={GROUP_TYPE.HIDDEN}
        fetchChats={fetchChats}
        resetChats={resetChats}
      />
      {!searchMode ? (
        <HiddenGroupChatListPanel
          selectedChatId={selectedChatId}
          unreadChatCount={unreadChatCount}
        />
      ) : (
        <HiddenGroupChatListSearchView selectedChatId={selectedChatId} />
      )}
    </>
  );
}

export default HiddenGroups;
